import { styled, Box } from '@mui/material';

import { classes as classesDescriptionWithIconBox } from '../DescriptionWithIconBox/styles';

export const OrderClientInfoContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(0.75),
}));

export const OrderClientInfoDescriptionContainer = styled('div')(
  ({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: theme.spacing(0.75),

    [`& .${classesDescriptionWithIconBox.container}`]: {
      color: theme.palette.text.secondary,

      [`& .${classesDescriptionWithIconBox.iconContainer} svg`]: {
        fontSize: 12,
      },
    },
  }),
);

export const OrderClientInfoDuplicatedChip = styled('div')(({ theme }) => ({
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: theme.typography.pxToRem(8),
  fontWeight: theme.typography.fontWeightBold,
  color: theme.palette.error.main,
  border: `1px solid ${theme.palette.error.main}`,
  padding: theme.spacing(0, 0.25),
  borderRadius: 14 / 2,
  height: 14,
  width: 34,
}));
